import React from 'react';
import SVG from 'react-inlinesvg';

import classes from './Badge.css';

const badge = (props) => {
    return (
        <div style={{textAlign: "center"}}>
            <div className={classes.Circle} style={{background: props.color}}>
                <SVG src={props.image}/>               
            </div>

            <p style={{color: props.color}}>{props.children}</p>
        </div>

    );

}

export default badge;


// WEBPACK FOOTER //
// ./client/src/components/Badge/Badge.js